import React, { Component, useState } from 'react';
import { connect } from 'react-redux';

import { ANY_ERROR } from '../../../action/user_action_types';


class AddAdminComp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      adminField: {
        email: ""
      },
      adminList:["admin","campaignAdmin", "userAdmin", "packageAdmin", "couponAdmin", "audioAdmin", "financeAdmin"],
      role:"admin"
    };
  }

  //Handle the admin fields
  handleChange = event => {
    let { name, value } = event.target;
    let { adminField } = this.state;
    this.setState({
      adminField: {
        ...adminField,
        [name]: value
      }
    });
  }

  handleObjective = role => {
    console.log(role);
    this.state.role = role;
    console.log(this.state);
  }

  //Adding an admin to database
  addAdmin = () => {
    let { adminField, role } = this.state;
    let { email }= adminField;
    console.log(role);
    let domain= email.slice(email.lastIndexOf("@")+1);
      console.log('Email domain', domain);
      if(email=== "") {
      this.props.showError("Email can not be blank!");
    }
    // else if(domain!= "affle.com" && domain!= "radiobigfm.com") {
    //   this.props.showError("Email must contain either affle.com or radiobigfm.com domain!");
    // }
    else if(domain!== "buyadsonbigfm.com" && domain!== "radiobigfm.com" ) {
      this.props.showError("Email must contain either buyadsonbigfm.com or radiobigfm.com domain!");
    }

    else {
      let data= { email, role};
      this.props.addAdmin(data);
    }
  };

  render() {
    let { adminField } = this.state;
    let { hidePopup }= this.props;
    let { email } = adminField;


    return (
      <div className="modal-overlay">
        <div className="modal-wrapper thankyou-popup" aria-modal aria-hidden tabIndex={-1} role="dialog">
          <div className="modal approval">
            <div className="modal-head-cross rate-modal">
              <button type="button" className="modal-close-button" onClick={hidePopup}>
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="approval-content modal-body">
                <div className="popup-container reqst-rejection">
                <h2>Add admin details</h2>
                  <div className="email">
                    <label htmlFor="email">Email</label>
                    <input type= "text" name= "email" placeholder="Email" value= {email} onChange= {this.handleChange} />
                  </div>

                  <div className="email">
                    <label htmlFor="role">Role</label>
                    <select onChange={(e) => {
                          this.handleObjective(e.target.value)
                        }}>
                          {this.state.adminList.map((o, i) => <option key={i} value={o}>{o}</option>)}
                    </select>
                  </div>

                    <div className="confirn-btn">
                    <button className="confirm-reqst" onClick={this.addAdmin}>{"ADD"}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

}

const mapDispatchToProps= dispatch=> {
  return {
    showError: error=> dispatch({
      type: ANY_ERROR,
      payload: error
    })
  }
}

export default connect(null, mapDispatchToProps)(AddAdminComp);


// WEBPACK FOOTER //
// ./web/components/admin/admin_management/AddAdmin.jsx